import { openMetadataApiClient } from '@/shared/api/core/axios-instance';

type DeleteGlossaryTermRequest = {
  termId: string;
  recursive?: boolean;
  hardDelete?: boolean;
};

export const deleteGlossaryTermApi = async ({
  termId,
  recursive = true,
  hardDelete = true,
}: DeleteGlossaryTermRequest): Promise<void> => {
  try {
    await openMetadataApiClient.delete(`/glossaryTerms/${encodeURIComponent(termId)}`, {
      params: {
        recursive,
        hardDelete,
      },
    });
  } catch (error) {
    console.error('Failed to delete glossary term:', error);
    throw error;
  }
};

export type { DeleteGlossaryTermRequest };
